import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { INSTANCE_ID_QUERY_PARAM_KEY, LOCAL_STORAGE_INSTANCE_ID_KEY } from '@frontend/utils/misc';

import { useLocalstorageParam } from './useLocalstorageParam';
import { useOpalUser } from './useOpalUser';

const useInstanceId = () => {
  const { opalUser } = useOpalUser();
  const [localInstanceId, setLocalInstanceId] = useLocalstorageParam(LOCAL_STORAGE_INSTANCE_ID_KEY);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const instanceIdInQuery = searchParams.get(INSTANCE_ID_QUERY_PARAM_KEY);
    if (instanceIdInQuery) {
      if (instanceIdInQuery !== localInstanceId) {
        setLocalInstanceId(instanceIdInQuery);
      }
    }
  }, [searchParams, setLocalInstanceId, localInstanceId]);

  useEffect(() => {
    if (opalUser?.instance?.instance_id && !localInstanceId) {
      setLocalInstanceId(opalUser.instance.instance_id);
    }
  }, [opalUser?.instance?.instance_id, setLocalInstanceId, localInstanceId]);

  return { instanceId: localInstanceId };
};

export { useInstanceId };
